const cryptoDes = require('./crypto-js/tripledes')
const cryptoUtf8 = require('./crypto-js/enc-utf8')
const cryptoEcb = require('./crypto-js/mode-ecb')
const cryptoZeropadding = require('./crypto-js/pad-zeropadding')

function cryptdes (str, key = 'Em$69#Pw') {
  return cryptoDes.encrypt(str, cryptoUtf8.parse(key), {
    mode: cryptoEcb,
    padding: cryptoZeropadding
  }).toString()
}

function isWindows () {
  return (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
}

/**
 * 唤起跨声聊天
 *
 * @param {string} employeeNumber - 员工工号
 * @param {string} chatMsg - 聊天窗口输入信息
 */
export async function openKuasheng (employeeNumber, chatMsg) {
  let href = ''
  if (chatMsg) {
    href = `kuasheng:send_erp_text_msg?sid=${employeeNumber}stype=0stext=${chatMsg}`
  } else {
    href = 'kuasheng:openChat?' + cryptdes(`${employeeNumber}`)
  }

  if (isWindows()) {
    window.erpOpen(href)
  }
}



// WEBPACK FOOTER //
// ./src/public/utils/open-ks.js